import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "46",
      height: "24",
      fill: "#4CAF50",
      rx: "12"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "34",
      cy: "12",
      r: "9",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }